import { LibraryModuleFormData } from "@/modules/learningCenter/features/ModuleLibrary/components/LibraryModuleForm/types";
import {
  LibraryModule,
  LibraryModulePayload,
} from "@/modules/learningCenter/features/ModuleLibrary/types/libraryModule";

/** Maps an existing library module (server graph) into editable form data. */
export const libraryModuleToFormData = (
  module: LibraryModule,
): LibraryModuleFormData => ({
  title: module.title,
  description: module.description ?? "",
  difficulty: module.difficulty ?? "",
  estimatedMinutes:
    module.estimatedMinutes != null ? String(module.estimatedMinutes) : "",
  tags: module.tags ?? [],
  blocks: module.blocks.map((block) => ({
    id: block.uuid,
    uuid: block.uuid,
    type: block.type,
    content: block.content ?? "",
    metadata: block.metadata,
  })),
});

/** Maps form data into the create/update request payload. */
export const formDataToLibraryModulePayload = (
  data: LibraryModuleFormData,
): LibraryModulePayload => {
  const trimmedMinutes = (data.estimatedMinutes ?? "").trim();

  return {
    title: data.title,
    description: data.description || null,
    difficulty: data.difficulty || null,
    estimatedMinutes: trimmedMinutes === "" ? null : Number(trimmedMinutes),
    tags: data.tags.map((tag) => tag.trim()).filter((tag) => tag !== ""),
    blocks: data.blocks.map((block, blockIndex) => ({
      uuid: block.uuid || null,
      type: block.type,
      content: block.content || null,
      orderNumber: blockIndex,
      metadata: block.metadata ?? null,
    })),
  };
};

export const emptyLibraryModuleFormData = (): LibraryModuleFormData => ({
  title: "",
  description: "",
  difficulty: "",
  estimatedMinutes: "",
  tags: [],
  blocks: [],
});
